import { render, staticRenderFns } from "./VersatileFilter.vue?vue&type=template&id=7ba2d780&scoped=true"
import script from "./VersatileFilter.vue?vue&type=script&lang=js"
export * from "./VersatileFilter.vue?vue&type=script&lang=js"
import style0 from "./VersatileFilter.vue?vue&type=style&index=0&id=7ba2d780&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba2d780",
  null
  
)

export default component.exports